import React from 'react';
import { Form, Input } from 'antd';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { ForgotPasswordFormData } from './types';
import { FormItem, ButtonWrapper, PrimaryButton, ResponsiveFormWrapper } from '../styles';

interface ForgotPasswordFormProps {
  control: Control<ForgotPasswordFormData, any>;
  errors: FieldErrors<ForgotPasswordFormData>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isLoading: boolean;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  control,
  errors,
  onSubmit,
  isLoading,
}) => {
  return (
    <ResponsiveFormWrapper>
      <Form layout="vertical" onFinish={onSubmit} size="large">
        <FormItem>
        <Form.Item
          label="Email Address"
          validateStatus={errors.email ? 'error' : ''}
          help={errors.email?.message}
          required
        >
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                type="email"
                placeholder="Enter your email address"
                style={{
                  borderRadius: '8px',
                }}
              />
            )}
          />
        </Form.Item>
      </FormItem>
      
      <ButtonWrapper>
        <PrimaryButton
          type="primary"
          htmlType="submit"
          block
          loading={isLoading}
        >
          Send Reset Code
        </PrimaryButton>
      </ButtonWrapper>
    </Form>
    </ResponsiveFormWrapper>
  );
};

export default ForgotPasswordForm;
